import { Web3ProviderInterface } from '../../types/web3';
import { createContext } from 'react';
import { EnvioGraphQLClient } from '@peeramid-labs/sdk';

export const Web3ProviderContext = createContext<Web3ProviderInterface>({
  logout: async () => {
    console.error('not initialized');
  },
  currentChain: undefined,
  account: null,
  isConnected: false,
  ensureEEAToken: undefined,
  publicClient: undefined,
  walletClient: undefined,
  envioClient: new EnvioGraphQLClient(),
});

export default Web3ProviderContext;
